import styled from "styled-components";
import { pulseNeonBlue } from "../../styles/animations";

export const Container = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 6}px 28px;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;

  @media (min-width: 1025px) {
    padding: ${({ theme }) => theme.CONSTANTS.XH * 4}px 48px;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 999;
`;

export const BackgroundImage = styled.img<{
  $top?: string;
  $bottom?: string;
  $left?: string;
  $right?: string;
  $opacity?: string;
  $blur?: string;
  $widthMobile?: string;
  $widthDesktop?: string;
  $topDesktop?: string;
  $bottomDesktop?: string;
  $leftDesktop?: string;
  $rightDesktop?: string;
}>`
  position: absolute;
  width: ${({ $widthMobile }) => $widthMobile || "220px"};
  opacity: ${({ $opacity }) => $opacity || "0.1"};
  filter: blur(${({ $blur }) => $blur || "1px"});
  pointer-events: none;
  z-index: 1;

  top: ${({ $top }) => $top || "auto"};
  bottom: ${({ $bottom }) => $bottom || "auto"};
  left: ${({ $left }) => $left || "auto"};
  right: ${({ $right }) => $right || "auto"};

  @media (min-width: 1025px) {
    width: ${({ $widthDesktop, $widthMobile }) =>
      $widthDesktop || $widthMobile || "260px"};
    top: ${({ $topDesktop, $top }) => $topDesktop || $top || "auto"};
    bottom: ${({ $bottomDesktop, $bottom }) =>
      $bottomDesktop || $bottom || "auto"};
    left: ${({ $leftDesktop, $left }) => $leftDesktop || $left || "auto"};
    right: ${({ $rightDesktop, $right }) => $rightDesktop || $right || "auto"};
  }
`;

export const Card = styled.div`
  overflow: hidden;
  width: 100%;
  max-width: 380px;
  background: ${({ theme }) => theme.THEME.background};
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 4}px 24px;
  backdrop-filter: blur(14px);
  text-align: center;
  box-shadow: 0 0 20px rgba(0, 217, 255, 0.2);

  @media (min-width: 1025px) {
    max-width: 1100px;
    width: 80%;
    padding: ${({ theme }) => theme.CONSTANTS.XH * 6}px 32px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Avatar = styled.img`
  width: ${({ theme }) => theme.CONSTANTS.XW * 25}px;
  height: ${({ theme }) => theme.CONSTANTS.XW * 25}px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  box-shadow: 0 0 8px rgba(0, 217, 255, 0.3);

  @media (min-width: 1025px) {
    width: ${({ theme }) => theme.CONSTANTS.XW * 14}px;
    height: ${({ theme }) => theme.CONSTANTS.XW * 14}px;
  }
`;

export const Name = styled.h2`
  color: ${({ theme }) => theme.THEME.neonBlue};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 32}px;
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 1}px;
  font-family: "Audiowide", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
  }
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  font-family: "Inter", sans-serif;
  margin-top: 8px;
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.5;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const MusicSection = styled.div`
  text-align: left;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 4}px;

  h3 {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
    font-family: "Sora", sans-serif;
    color: ${({ theme }) => theme.THEME.white};
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;

    @media (min-width: 1025px) {
      font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
    }
  }
`;

export const EventsSection = styled.div`
  text-align: left;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 4}px;

  h3 {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
    font-family: "Sora", sans-serif;
    color: ${({ theme }) => theme.THEME.white};
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 1}px;

    @media (min-width: 1025px) {
      font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
    }
  }

  p {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
    font-family: "Inter", sans-serif;
    color: ${({ theme }) => theme.THEME.white};
    margin-bottom: 4px;
  }
`;

export const SocialIcons = styled.div`
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.CONSTANTS.XW * 4}px;

  img {
    height: 26px;
    width: auto;
    cursor: pointer;
    filter: drop-shadow(0 0 4px rgba(0, 217, 255, 0.4));
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.15);
      filter: drop-shadow(0 0 6px ${({ theme }) => theme.THEME.neonBlue});
    }

    @media (min-width: 1025px) {
      height: 30px;
    }
  }
`;

export const Section = styled.div`
  text-align: left;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 4}px;

  @media (min-width: 1025px) {
    margin-top: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  }
`;

export const SectionTitle = styled.h3`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  font-family: "Sora", sans-serif;
  color: ${({ theme }) => theme.THEME.white};
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const Paragraph = styled.p`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  font-family: "Inter", sans-serif;
  color: ${({ theme }) => theme.THEME.white};
  margin-bottom: 4px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const VideoImage = styled.img`
  width: 100%;
  border-radius: 12px;
  object-fit: cover;
  display: block;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 6}px;

  @media (min-width: 1025px) {
    width: 90%;
    margin: ${({ theme }) => theme.CONSTANTS.XH * 6}px auto 0 auto;
  }

  &:hover {
    box-shadow: 0 0 10px 2px ${({ theme }) => theme.THEME.neonBlue};
  }

  &:active {
    animation: ${pulseNeonBlue} 8s ease infinite;
  }
`;
